import { render, staticRenderFns } from "./SelectConcernElementsButton.vue?vue&type=template&id=0008d72d&scoped=true&"
import script from "./SelectConcernElementsButton.vue?vue&type=script&lang=js&"
export * from "./SelectConcernElementsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008d72d",
  null
  
)

export default component.exports